<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title1">The Lighten Up<br/><span class="bborder">Cookbook</span></h1>
<p class="subtitle">103 Easy, Slimmed-Down Favorites<br/>for Breakfast, Lunch, and Dinner<br/>Everyone Will Love</p>
<h2 class="author">Addie Gundry</h2>
<p class="logo"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?fccedd72